import {Injectable} from '@angular/core';
import {FormControl, Validators, FormBuilder, FormGroup, AbstractControl} from "@angular/forms";

@Injectable()
export class MarcacaoModel {

  public field: any = {

    responsavel:      <string> '',
    marcador:         <string> '',
    data_marcacao:    <string> '',
    fornecedor:       <string> '',
    condicao_pagto:   <string> '',
    transportadora:   <string> '',
    tipo_frete:       <string> '',
    valor_frete:      <string> '',
    forma_pagto:      <string> '',


    blocos: <any> []

  };

  constructor(public formBuilder: FormBuilder) {
    this.resetFormMarcacao();
  }

  resetFormMarcacao() {
    for (let prop in this.field) {
      eval("this.field." + prop + " = '' ");
    };
  }

}



// WEBPACK FOOTER //
// ./src/model/marcacao.model.ts